/*
 * This file is part of the https://gitlab-intern.easd-support.de/easd/p26s26_energie_watchdog project.
 *
 * (c) 2026 EA Systems Dresden GmbH
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import { NavLink } from 'react-router';

/* Import context functions */
import { useI18n } from '@/context/I18nContext';

/* Import configuration */
import {
    LAYOUT_SECTION_CONFIGS,
    LAYOUT_SECTION_GROUP_CONFIGS,
} from '@/config/layoutSections';

function LayoutsTab() {
    const { t } = useI18n();

    return (
        <div className="flex flex-col gap-6" aria-label={t('Layouts')}>
            <section className="flex flex-col gap-2">
                <h2>{t('Layouts')}</h2>
                <p>{t('Select one layout building block to open its examples and implementation details:')}</p>
            </section>
            {LAYOUT_SECTION_GROUP_CONFIGS.map((group) => {
                const sections = LAYOUT_SECTION_CONFIGS.filter((section) => section.group === group.key);

                return (
                    <section key={group.key} className="flex flex-col gap-3">
                        <div className="flex flex-col gap-1">
                            <h3>{t(group.label)}</h3>
                            <p className="text-base-content/70">{t(group.description)}</p>
                        </div>
                        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-4">
                            {sections.map((section) => (
                                <NavLink
                                    key={section.key}
                                    to={section.route}
                                    className="dashboard-panel interactive-surface !min-h-44 no-underline transition-[background,transform] duration-150"
                                >
                                    <div className="flex h-full w-full flex-col items-start justify-center gap-3 px-6 text-left">
                                        <div className="flex w-full items-start justify-between gap-3">
                                            <span className="text-xl font-semibold">{t(section.label)}</span>
                                            <span className={`badge shrink-0 ${section.badgeClassName}`}>
                                                {t(section.badgeLabel)}
                                            </span>
                                        </div>
                                        <span className="text-sm text-base-content/70">
                                            {t(section.description)}
                                        </span>
                                    </div>
                                </NavLink>
                            ))}
                        </div>
                    </section>
                );
            })}
        </div>
    );
}

export default LayoutsTab;
